import { useEffect, useState } from 'react';

export const getInitialTheme = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const storedPrefs = window.localStorage.getItem('color-theme');
    if (storedPrefs) return storedPrefs;
    const userMedia = window.matchMedia('(prefers-color-scheme: dark)');
    if (userMedia.matches) return 'dark';
    return 'light';
  }
  return 'light';
};

// TO DO: remote to ignore default them to dark
export const setThemeHeader = (newTheme) => {
  const root = window.document.documentElement;
  localStorage.setItem('color-theme', newTheme);
  root.classList.add(newTheme);
  root.setAttribute('data-theme', newTheme);
};

// export const setThemeHeader = (newTheme, oldTheme) => {
//   const root = window.document.documentElement;
//   localStorage.setItem('color-theme', newTheme);
//   if (oldTheme) root.classList.remove(oldTheme);
//   root.classList.add(newTheme);
//   root.setAttribute('data-theme', newTheme);
// };

const useDarkMode = () => {
  const [colorTheme, changeTheme] = useState('dark');
  // const [colorTheme, changeTheme] = useState(getInitialTheme());
  setThemeHeader(colorTheme);

  // TO DO: remote to ignore default them to dark
  useEffect(() => {
    setThemeHeader('dark'); // Set the theme to dark on component mount
  }, []);

  // TO DO: remote to ignore default them to dark
  const forceDarkTheme = (newTheme) => {
    if (newTheme !== 'dark') {
      changeTheme('dark');
      setThemeHeader('dark');
    }
  };

  // return [colorTheme, changeTheme];
  return [colorTheme, forceDarkTheme];
};

export default useDarkMode;
